// admin.users.tsx — T094 (4/5)
// Route : /admin/users

import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/users")({
  component: function AdminUsersRoute() {
    return <Outlet />;
  },
});
